// Generated by protoc-gen-vendasta-ts — DO NOT EDIT
/* eslint-disable */
import { defer } from 'rxjs';
import { map } from 'rxjs/operators';
import { createGoalRequestToJson, createGoalResponseFromJson, deleteGoalRequestToJson, getGoalRequestToJson, getGoalResponseFromJson, getHydratedPromptRequestToJson, getHydratedPromptResponseFromJson, getMultiGoalRequestToJson, getMultiGoalResponseFromJson, goalsDisabledForAccountGroupRequestToJson, goalsDisabledForAccountGroupResponseFromJson, listGoalsRequestToJson, listGoalsResponseFromJson, serializeGoalRequestToJson, serializeGoalResponseFromJson, updateGoalRequestToJson, upsertGoalRequestToJson, validateGoalsRequestToJson, validateGoalsResponseFromJson, validatePromptRequestToJson, validatePromptResponseFromJson } from './codec';
import { fetchRpc } from '@vendasta/protos/fetch-transport';
import { getGlobalTransport } from '@vendasta/protos/transport';
export async function upsert(request) {
    await fetchRpc('ai_assistants.v1alpha1.GoalService/Upsert', upsertGoalRequestToJson(request));
}
export function upsert$(request, options) {
    return defer(() => upsertWithTransport$(getGlobalTransport(), request, options));
}
export function upsertWithTransport$(transport, request, options) {
    return transport
        .post('ai_assistants.v1alpha1.GoalService/Upsert', upsertGoalRequestToJson(request), options)
        .pipe(map(() => undefined));
}
export async function create(request) {
    const raw = await fetchRpc('ai_assistants.v1alpha1.GoalService/Create', createGoalRequestToJson(request));
    return createGoalResponseFromJson(raw);
}
export function create$(request, options) {
    return defer(() => createWithTransport$(getGlobalTransport(), request, options));
}
export function createWithTransport$(transport, request, options) {
    return transport
        .post('ai_assistants.v1alpha1.GoalService/Create', createGoalRequestToJson(request), options)
        .pipe(map(resp => createGoalResponseFromJson(resp)));
}
export async function update(request) {
    await fetchRpc('ai_assistants.v1alpha1.GoalService/Update', updateGoalRequestToJson(request));
}
export function update$(request, options) {
    return defer(() => updateWithTransport$(getGlobalTransport(), request, options));
}
export function updateWithTransport$(transport, request, options) {
    return transport
        .post('ai_assistants.v1alpha1.GoalService/Update', updateGoalRequestToJson(request), options)
        .pipe(map(() => undefined));
}
export async function get(request) {
    const raw = await fetchRpc('ai_assistants.v1alpha1.GoalService/Get', getGoalRequestToJson(request));
    return getGoalResponseFromJson(raw);
}
export function get$(request, options) {
    return defer(() => getWithTransport$(getGlobalTransport(), request, options));
}
export function getWithTransport$(transport, request, options) {
    return transport
        .post('ai_assistants.v1alpha1.GoalService/Get', getGoalRequestToJson(request), options)
        .pipe(map(resp => getGoalResponseFromJson(resp)));
}
export async function getMulti(request) {
    const raw = await fetchRpc('ai_assistants.v1alpha1.GoalService/GetMulti', getMultiGoalRequestToJson(request));
    return getMultiGoalResponseFromJson(raw);
}
export function getMulti$(request, options) {
    return defer(() => getMultiWithTransport$(getGlobalTransport(), request, options));
}
export function getMultiWithTransport$(transport, request, options) {
    return transport
        .post('ai_assistants.v1alpha1.GoalService/GetMulti', getMultiGoalRequestToJson(request), options)
        .pipe(map(resp => getMultiGoalResponseFromJson(resp)));
}
export async function delete_(request) {
    await fetchRpc('ai_assistants.v1alpha1.GoalService/Delete', deleteGoalRequestToJson(request));
}
export function delete_$(request, options) {
    return defer(() => delete_WithTransport$(getGlobalTransport(), request, options));
}
export function delete_WithTransport$(transport, request, options) {
    return transport
        .post('ai_assistants.v1alpha1.GoalService/Delete', deleteGoalRequestToJson(request), options)
        .pipe(map(() => undefined));
}
export async function list(request) {
    const raw = await fetchRpc('ai_assistants.v1alpha1.GoalService/List', listGoalsRequestToJson(request));
    return listGoalsResponseFromJson(raw);
}
export function list$(request, options) {
    return defer(() => listWithTransport$(getGlobalTransport(), request, options));
}
export function listWithTransport$(transport, request, options) {
    return transport
        .post('ai_assistants.v1alpha1.GoalService/List', listGoalsRequestToJson(request), options)
        .pipe(map(resp => listGoalsResponseFromJson(resp)));
}
export async function goalsDisabledForAccountGroup(request) {
    const raw = await fetchRpc('ai_assistants.v1alpha1.GoalService/GoalsDisabledForAccountGroup', goalsDisabledForAccountGroupRequestToJson(request));
    return goalsDisabledForAccountGroupResponseFromJson(raw);
}
export function goalsDisabledForAccountGroup$(request, options) {
    return defer(() => goalsDisabledForAccountGroupWithTransport$(getGlobalTransport(), request, options));
}
export function goalsDisabledForAccountGroupWithTransport$(transport, request, options) {
    return transport
        .post('ai_assistants.v1alpha1.GoalService/GoalsDisabledForAccountGroup', goalsDisabledForAccountGroupRequestToJson(request), options)
        .pipe(map(resp => goalsDisabledForAccountGroupResponseFromJson(resp)));
}
export async function validateGoals(request) {
    const raw = await fetchRpc('ai_assistants.v1alpha1.GoalService/ValidateGoals', validateGoalsRequestToJson(request));
    return validateGoalsResponseFromJson(raw);
}
export function validateGoals$(request, options) {
    return defer(() => validateGoalsWithTransport$(getGlobalTransport(), request, options));
}
export function validateGoalsWithTransport$(transport, request, options) {
    return transport
        .post('ai_assistants.v1alpha1.GoalService/ValidateGoals', validateGoalsRequestToJson(request), options)
        .pipe(map(resp => validateGoalsResponseFromJson(resp)));
}
export async function serializeGoal(request) {
    const raw = await fetchRpc('ai_assistants.v1alpha1.GoalService/SerializeGoal', serializeGoalRequestToJson(request));
    return serializeGoalResponseFromJson(raw);
}
export function serializeGoal$(request, options) {
    return defer(() => serializeGoalWithTransport$(getGlobalTransport(), request, options));
}
export function serializeGoalWithTransport$(transport, request, options) {
    return transport
        .post('ai_assistants.v1alpha1.GoalService/SerializeGoal', serializeGoalRequestToJson(request), options)
        .pipe(map(resp => serializeGoalResponseFromJson(resp)));
}
export async function validatePrompt(request) {
    const raw = await fetchRpc('ai_assistants.v1alpha1.GoalService/ValidatePrompt', validatePromptRequestToJson(request));
    return validatePromptResponseFromJson(raw);
}
export function validatePrompt$(request, options) {
    return defer(() => validatePromptWithTransport$(getGlobalTransport(), request, options));
}
export function validatePromptWithTransport$(transport, request, options) {
    return transport
        .post('ai_assistants.v1alpha1.GoalService/ValidatePrompt', validatePromptRequestToJson(request), options)
        .pipe(map(resp => validatePromptResponseFromJson(resp)));
}
export async function getHydratedPrompt(request) {
    const raw = await fetchRpc('ai_assistants.v1alpha1.GoalService/GetHydratedPrompt', getHydratedPromptRequestToJson(request));
    return getHydratedPromptResponseFromJson(raw);
}
export function getHydratedPrompt$(request, options) {
    return defer(() => getHydratedPromptWithTransport$(getGlobalTransport(), request, options));
}
export function getHydratedPromptWithTransport$(transport, request, options) {
    return transport
        .post('ai_assistants.v1alpha1.GoalService/GetHydratedPrompt', getHydratedPromptRequestToJson(request), options)
        .pipe(map(resp => getHydratedPromptResponseFromJson(resp)));
}
